import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ConfirmDialog({alert, onAgree = f => f, onDisAgree = f => f }) {
  const [open, setOpen] = React.useState(true);

  const handleAgree = () => {
    onAgree(null)
    handleClose()
  };

  const handleDisagree = () => {
    onDisAgree(null)
    handleClose()
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {alert.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {alert.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDisagree}>Don't {alert.action}</Button>
          <Button onClick={handleAgree} autoFocus>
            {alert.action}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
